// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.org-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, opacity 160ms ease;
}

.org-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.org-btn-secondary {
  border: 1px solid #d8e0ec;
  background: #fff;
  color: #334155;
}

.org-btn-secondary:hover:not(:disabled) {
  background: #f1f5f9;
}

.org-btn-primary {
  border: 1px solid #111827;
  background: #111827;
  color: #fff;
}

.org-btn-primary:hover:not(:disabled) {
  background: #1f2937;
}

.org-btn-danger {
  border: 1px solid #f0c2c2;
  background: #fff;
  color: #d14343;
}

.org-btn-danger:hover:not(:disabled) {
  background: #fdf0f0;
}

.org-count-badge {
  flex-shrink: 0;
  padding: 4px 12px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
}

.org-role-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.org-role-badge.organizer {
  background: #e7f6ec;
  color: #2f8f4e;
}

.org-role-badge.regular {
  background: #eef2f7;
  color: #475569;
}

.org-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid #eef2f7;
  background: #fafbfd;
}
`, "",{"version":3,"sources":["webpack://./src/styles/org-buttons.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB","sourcesContent":[".org-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 9px 18px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: background 160ms ease, border-color 160ms ease, opacity 160ms ease;\n}\n\n.org-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.org-btn-secondary {\n  border: 1px solid #d8e0ec;\n  background: #fff;\n  color: #334155;\n}\n\n.org-btn-secondary:hover:not(:disabled) {\n  background: #f1f5f9;\n}\n\n.org-btn-primary {\n  border: 1px solid #111827;\n  background: #111827;\n  color: #fff;\n}\n\n.org-btn-primary:hover:not(:disabled) {\n  background: #1f2937;\n}\n\n.org-btn-danger {\n  border: 1px solid #f0c2c2;\n  background: #fff;\n  color: #d14343;\n}\n\n.org-btn-danger:hover:not(:disabled) {\n  background: #fdf0f0;\n}\n\n.org-count-badge {\n  flex-shrink: 0;\n  padding: 4px 12px;\n  border-radius: 999px;\n  background: #eef2f7;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.org-role-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.org-role-badge.organizer {\n  background: #e7f6ec;\n  color: #2f8f4e;\n}\n\n.org-role-badge.regular {\n  background: #eef2f7;\n  color: #475569;\n}\n\n.org-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 24px;\n  border-top: 1px solid #eef2f7;\n  background: #fafbfd;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
